export class SessionStorageService {
  private AUTHORIZATION_TOKEN: string = 'crmAuthorizationToken';

  setAuthorizationToken(token:string) {
    sessionStorage.setItem(this.AUTHORIZATION_TOKEN, token);
  }
  getAuthorizationToken() {
    return sessionStorage.getItem(this.AUTHORIZATION_TOKEN);
  }

  removeAuthorizationToken() {
    sessionStorage.removeItem(this.AUTHORIZATION_TOKEN);
  }
}
